import { useUserStore, UserStateModel } from "./store";

export const useUserState = (): UserStateModel => useUserStore();
